import React, { useState } from "react";
import { useFormikContext } from "formik";
import { Tabs, Tab, Checkbox, FormControlLabel, Box } from "@mui/material";
import { CircularProgress } from "@mui/material";
import FormElement from "./GetFormElement ";
import CSVUpload from "./CSVUpload";
import ImageUploadButton from "./ImageUploadButton";
import CancelOrderButton from "./CancelOrderButton";
import Button from "@mui/material/Button";
import CatalogueButtons from "./CatalogueButtons";
import { useEffect } from "react";

// Default filter-field mapping — maps API parameter names to Formik field names
const DEFAULT_FILTER_FIELDS = {
  productionOrderNumber: "ORDER_NUMBER",
  campaign: "SEASON",
  supplierCode: "SUPPLIER_CODE",
};

// Isolated child so useFormikContext only runs when EDI button is mounted
const EDIButtonInline = ({ handleEDIClick, ediSchemaConfig, ediLoading }) => {
  const { values } = useFormikContext();
  // Read filter field names and button text from config (with defaults)
  const filterFields = ediSchemaConfig?.filterFields || DEFAULT_FILTER_FIELDS;
  const buttonText = ediSchemaConfig?.buttonText || "Load EDI Data";
  return (
    <div style={{ width: "100%", margin: "10px 20px" }}>
      <Button
        variant="contained"
        color="primary"
        disabled={!!ediLoading}
        onClick={() => {
          // Build filters dynamically from config — any number of filters
          const filters = {};
          Object.entries(filterFields).forEach(([apiParam, formFieldName]) => {
            filters[apiParam] = values?.[formFieldName];
          });
          handleEDIClick(filters, values);
        }}
        data-testid="edi-integration-btn"
      >
        {buttonText}
      </Button>
    </div>
  );
};
// Removed unused showCat; CatalogueButtons handles catalogue popups
// Function to group elements by tab
const groupByTab = (elements) => {
  return elements.reduce((acc, element) => {
    const tab = element.tabValue || "default";
    if (!acc[tab]) acc[tab] = [];
    acc[tab].push(element);
    return acc;
  }, {});
};
const DynamicFormElements = ({
  values,
  uploaded,
  handleFileUpload,
  errorMessage,
  csvUploadEnabled,
  setFile1,
  setFile2,
  combineCSVData,
  userSelection,
  multipleCsvUplaodEnabled,
  schemaName,
  searchParams,
  divisionID,
  ELCDropDown,
  setELCDropDown,
  toggleTescoFileUploaded,
  csvFileNameStartLatters,
  csvFileNameEndWith,
  allow100PercentFibreWithourGarmentPart,
  SetcatalogueChildOptn,
  catalogueChildOptn,
  showEDIButton,
  ediSchemaConfig,
  handleEDIClick,
  ediLoading,
  ediTableVisible,
  ...props
}) => {
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem("activeTab");
    return savedTab ? parseInt(savedTab) : 0;
  });
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);
  const handleFileChange = (event, fileNumber) => {
    const file = event.target.files[0];
    if (fileNumber === 1) {
      setFile1(file);
    } else {
      setFile2(file);
    }
  };
  if (!uploaded) return null;

  const groupedByTabs = groupByTab(values);

  const handleTabNavigation = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleSelectionChange = (event) => {
    props.setUserSelection(event.target.checked);
  };

  const handleCheckboxChange = (tab) => {
    props.setSelectedTabs((prevSelectedTabs) => {
      if (prevSelectedTabs.includes(tab)) {
        return prevSelectedTabs.filter((selectedTab) => selectedTab !== tab);
      } else {
        return [...prevSelectedTabs, tab];
      }
    });
  };

  // showCat removed; handled within CatalogueButtons

  const getTabLabel = (tab, index, schemaName) => {
    let result;

    switch (schemaName) {
      case "Tempe CSV Online Ordering":
        result = "TEMPE - Lefties";
        break;
      case "Tempe - Zara CSV Online Ordering":
        result = "TEMPE - Zara";
        break;
      default:
        result = schemaName;
    }

    switch (index) {
      case 0:
        return `${result} Price Tickets`;

      case 1:
        return `${result} Stickers Box`;

      case 2:
        return `${result} Hang Tag`;

      default:
        return "Default Tab";
    }
  };

  return (
    <>
      <CatalogueButtons
        store_grp={props.store_grp}
        divisionID={divisionID}
        searchParams={searchParams}
        keyValues={props.keyValues}
        catId={props.catId}
      />
      {csvUploadEnabled ? (
        <div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabNavigation}
              aria-label="tab navigation"
              sx={{
                flexGrow: 1,
                borderBottom: "2px solid #007bff",
              }}
            >
              {Object.keys(groupedByTabs).map((tab, index) => (
                <Tab
                  key={tab}
                  value={index}
                  iconPosition="start"
                  icon={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={props.selectedTabs.includes(tab)}
                            onChange={() => handleCheckboxChange(tab)}
                            color="primary"
                          />
                        }
                        sx={{
                          marginRight: "8px",
                        }}
                      />
                    </Box>
                  }
                  label={
                    <span style={{ fontWeight: "bold" }}>
                      {getTabLabel(tab, index, schemaName)}
                    </span>
                  }
                  sx={{
                    borderRadius: "5px",
                    padding: "10px 15px",
                    backgroundColor:
                      activeTab === index ? "#e9f7ff" : "transparent",
                    "&:hover": {
                      backgroundColor:
                        activeTab !== index ? "#f0f0f0" : "transparent",
                    },
                    textTransform: "none",
                  }}
                />
              ))}
            </Tabs>
          </Box>

          <div>
            {Object.keys(groupedByTabs).map((tab, index) =>
              activeTab === index ? (
                <div
                  key={tab}
                  style={{
                    padding: "20px",
                    marginTop: "10px",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    boxShadow: "0 4px 8px rgba(0, 123, 255, 0.1)",
                  }}
                >
                  {tab === "1" ? (
                    <>
                      {multipleCsvUplaodEnabled && (
                        <label>
                          Select checkbox if you want to upload file for indian
                          market
                          <input
                            type="checkbox"
                            checked={userSelection}
                            onChange={handleSelectionChange}
                            data-testid="user-selection-checkbox"
                          />
                        </label>
                      )}
                      <CSVUpload
                        handleFileUpload={
                          userSelection ? handleFileChange : handleFileUpload
                        }
                        errorMessage={errorMessage}
                        csvUploadEnabled={csvUploadEnabled}
                        fileNumber={1}
                        fileInputRef={props.fileInput1Ref}
                        multipleCsvUplaodEnabled={multipleCsvUplaodEnabled}
                        userSelection={userSelection}
                        csvFileNameStartLatters={csvFileNameStartLatters}
                        csvFileNameEndWith={csvFileNameEndWith}
                      />
                      {userSelection && multipleCsvUplaodEnabled && (
                        <>
                          <CSVUpload
                            handleFileUpload={handleFileChange}
                            errorMessage={errorMessage}
                            csvUploadEnabled={csvUploadEnabled}
                            fileNumber={2}
                            fileInputRef={props.fileInput2Ref}
                            multipleCsvUplaodEnabled={multipleCsvUplaodEnabled}
                            userSelection={userSelection}
                            csvFileNameStartLatters={csvFileNameStartLatters}
                            csvFileNameEndWith={csvFileNameEndWith}
                          />

                          <Button
                            variant="contained"
                            onClick={handleFileUpload}
                          >
                            Upload Combine CSVs
                          </Button>
                        </>
                      )}
                  
                    </>
                  ) : (
                    <ImageUploadButton {...props} />
                  )}
                  {groupedByTabs[tab]?.map((element, ind) => {
                    const isTable = ["TAB", "CTB", "CCL"].includes(element.prefix);
                    return isTable ? (
                      <div key={ind} style={{ margin: "4px 0" }}>
                        <FormElement
                          elementName={element}
                          {...props}
                          SetcatalogueChildOptn={SetcatalogueChildOptn}
                          catalogueChildOptn={catalogueChildOptn}
                        />
                      </div>
                    ) : null;
                  })}
                  <div className="form-fields-grid">
                    {groupedByTabs[tab]?.filter((el) => !["TAB", "CTB", "CCL"].includes(el.prefix)).map((element, ind) => (
                      <div key={`nt-${ind}`} className="form-field-cell">
                        <FormElement
                          elementName={element}
                          {...props}
                          SetcatalogueChildOptn={SetcatalogueChildOptn}
                          catalogueChildOptn={catalogueChildOptn}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : null
            )}
          </div>
        </div>
      ) : (
        // Render normal page without tabs if CSV upload is not enabled
        // Items are rendered in their natural schemaItem order, grouped into
        // consecutive runs of table vs non-table fields for correct layout.
        <div>
          {(() => {
            const allItems = Object.values(values);
            // Group consecutive items by type (table vs non-table)
            const groups = [];
            let currentGroup = null;
            allItems.forEach((item) => {
              const isTable = ["TAB", "CTB", "CCL"].includes(item.prefix);
              if (!currentGroup || currentGroup.isTable !== isTable) {
                currentGroup = { isTable, items: [] };
                groups.push(currentGroup);
              }
              currentGroup.items.push(item);
            });

            const firstTableIdx = groups.findIndex((g) => g.isTable);
            const rendered = [];

            groups.forEach((group, gIdx) => {
              // Insert EDI button just before the first table group
              if (gIdx === firstTableIdx) {
                if (showEDIButton && !searchParams?.get("OCC")) {
                  rendered.push(
                    <EDIButtonInline key="edi-btn" handleEDIClick={handleEDIClick} ediSchemaConfig={ediSchemaConfig} ediLoading={ediLoading} />
                  );
                }
                if (ediLoading) {
                  rendered.push(
                    <div key="edi-loading" style={{ width: "100%", textAlign: "center", padding: "20px" }}>
                      <CircularProgress size={40} />
                      <p style={{ marginTop: 8 }}>Loading EDI data...</p>
                    </div>
                  );
                }
              }

              if (group.isTable) {
                // Table fields — full width, hidden when EDI loading
                if (showEDIButton && !ediTableVisible) return;
                group.items.forEach((key, ind) => {
                  rendered.push(
                    <div key={`tab-${gIdx}-${ind}`} style={{ width: "100%", margin: "4px 0" }}>
                      <FormElement
                        elementName={key}
                        {...props}
                        searchParams={searchParams}
                        divisionID={divisionID}
                        ELCDropDown={ELCDropDown}
                        setELCDropDown={setELCDropDown}
                        toggleTescoFileUploaded={toggleTescoFileUploaded}
                        allow100PercentFibreWithourGarmentPart={
                          allow100PercentFibreWithourGarmentPart
                        }
                        SetcatalogueChildOptn={SetcatalogueChildOptn}
                        catalogueChildOptn={catalogueChildOptn}
                      />
                    </div>
                  );
                });
              } else {
                // Non-table fields — responsive grid
                rendered.push(
                  <div key={`ntg-${gIdx}`} className="form-fields-grid">
                    {group.items.map((key, ind) => (
                      <div key={`nt-${gIdx}-${ind}`} className="form-field-cell">
                        <FormElement
                          elementName={key}
                          {...props}
                          searchParams={searchParams}
                          divisionID={divisionID}
                          ELCDropDown={ELCDropDown}
                          setELCDropDown={setELCDropDown}
                          toggleTescoFileUploaded={toggleTescoFileUploaded}
                          allow100PercentFibreWithourGarmentPart={
                            allow100PercentFibreWithourGarmentPart
                          }
                          SetcatalogueChildOptn={SetcatalogueChildOptn}
                          catalogueChildOptn={catalogueChildOptn}
                        />
                      </div>
                    ))}
                  </div>
                );
              }
            });

            // If no table group exists, still show EDI button at the end
            if (firstTableIdx === -1) {
              if (showEDIButton && !searchParams?.get("OCC")) {
                rendered.push(
                  <EDIButtonInline key="edi-btn" handleEDIClick={handleEDIClick} ediSchemaConfig={ediSchemaConfig} ediLoading={ediLoading} />
                );
              }
              if (ediLoading) {
                rendered.push(
                  <div key="edi-loading" style={{ width: "100%", textAlign: "center", padding: "20px" }}>
                    <CircularProgress size={40} />
                    <p style={{ marginTop: 8 }}>Loading EDI data...</p>
                  </div>
                );
              }
            }

            return rendered;
          })()}
        </div>
      )}
    </>
  );
};

export default DynamicFormElements;
